import React from 'react';

import { Deploy } from '@block-explorer/entities';
import { Table } from '@block-explorer/ui';
import { TableRowType, useMatchMedia } from '@make-software/cspr-ui';
import { useGetPaginatedDeploys } from '../../../hooks/event-store-hooks';

import HomeDeploysListHeaders from './HomeDeploysListHeaders';
import HomeDeploysListItem from './HomeDeploysListItem';
import { TableLoader } from '../../../components/page-data-table/table-loader';
import { useSelector } from 'react-redux';
import { RootState } from 'typesafe-actions';
import { AccountDataProvider } from '../../../services/account-data-service';
import {
  deriveHashListByKeysFromDeployArgsObject,
  deriveHashListByKeysFromObject,
} from '../../../utils/account';
import {
  auctionMessage,
  ftTokenMessage,
  nftTokenMessage,
  csprMarkerMessage,
  associatedKeyMessage,
} from '../../../services/deploy-action-messages';

export interface LatestDeploysListProps {}

export const HomeDeploysList = (props: LatestDeploysListProps) => {
  const rowsPerPage = useMatchMedia([5, 8, 12], []);
  const { selectedCurrency: currency } = useSelector(
    (state: RootState) => state.currencies
  );

  const { data: deploysData, loading } = useGetPaginatedDeploys({
    includes: `rate(${currency.id}),contract_entrypoint,contract_package,account_info,centralized_account_info`,
    page_size: rowsPerPage,
  });

  if (loading || !deploysData) {
    return (
      <Table
        renderDataHeaders={() => <HomeDeploysListHeaders />}
        renderData={() => (
          <TableLoader
            columnsLength={3}
            rowsLength={rowsPerPage}
            tableRowType={TableRowType.TextWithAvatar}
          />
        )}
      />
    );
  }

  const publicKeysList =
    deriveHashListByKeysFromObject(deploysData, [
      'callerPublicKey',
      'callerHash',
    ]) || [];

  const accountHashesListArgs =
    deriveHashListByKeysFromDeployArgsObject(deploysData, [
      ...auctionMessage().getRelevantAccountHashesFromArgs(),
      ...csprMarkerMessage().getRelevantAccountHashesFromArgs(),
      ...nftTokenMessage().getRelevantAccountHashesFromArgs(),
      ...ftTokenMessage().getRelevantAccountHashesFromArgs(),
      ...['target'], // Transfer arguments
    ]) || [];

  const combinedKeysList = [...publicKeysList, ...accountHashesListArgs];

  return (
    <AccountDataProvider accountHashes={combinedKeysList}>
      <Table
        renderDataHeaders={() => <HomeDeploysListHeaders />}
        renderData={() =>
          deploysData.map((deploy: Deploy, index) => (
            <HomeDeploysListItem key={index} data={deploy} loading={loading} />
          ))
        }
      />
    </AccountDataProvider>
  );
};

export default HomeDeploysList;
